import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ShoppingBag } from 'lucide-react';
import { useShopConfig } from '../contexts/ShopConfigContext';

const THUMBS = ['/images/shop/eco-all-purpose-cleaner.jpg', '/images/shop/microfibre-cloth-set.jpg', '/images/shop/home-care.jpg', '/images/shop/laundry.jpg'];

export const ShopBanner = () => {
  const { live } = useShopConfig();
  return (
    <section className="py-12 bg-white" data-testid="shop-banner">
      <div className="container mx-auto px-4">
        <Link
          to="/shop"
          data-testid="shop-banner-link"
          className="group relative block overflow-hidden rounded-[2rem] bg-gray-900 text-white grain hover:shadow-2xl hover:shadow-pink-200/50 transition-shadow duration-500"
        >
          <div className="absolute -right-24 -top-24 w-80 h-80 rounded-full bg-pink-600/40 blur-3xl group-hover:bg-pink-500/50 transition-colors duration-700" aria-hidden="true" />
          <div className="relative grid md:grid-cols-12 items-center gap-8 px-8 py-10 lg:px-14 lg:py-12">
            <div className="md:col-span-7">
              <span className="inline-flex items-center gap-2 text-pink-300 text-xs font-semibold tracking-[0.2em] uppercase">
                <ShoppingBag className="w-4 h-4" /> {live ? 'Online shop — now open' : 'Online shop — coming soon'}
              </span>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mt-3">
                {live ? 'Shop the products our cleaners trust.' : 'Professional cleaning products, delivered to your door.'}
              </h2>
              <p className="text-gray-300 mt-4 max-w-xl text-base">
                {live ? 'Cleaning essentials, kitchen, bathroom, laundry and home care — with secure checkout.' : 'Cleaning essentials, kitchen, bathroom, laundry and home care. Be the first to know when we launch.'}
              </p>
              <span className="inline-flex items-center gap-2 mt-7 rounded-full bg-white text-gray-900 font-semibold px-6 py-3 group-hover:bg-pink-400 group-hover:text-white transition-colors">
                {live ? 'Visit the shop' : 'Get early access'} <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </span>
            </div>
            <div className="md:col-span-5 hidden md:flex justify-end">
              <div className="flex -space-x-8">
                {THUMBS.map((src, i) => (
                  <img
                    key={src}
                    src={src}
                    alt=""
                    className="w-28 h-28 lg:w-36 lg:h-36 rounded-3xl object-cover border-4 border-gray-900 shadow-xl group-hover:-translate-y-2 transition-transform duration-500"
                    style={{ transitionDelay: `${i * 60}ms`, transform: `rotate(${(i - 1.5) * 4}deg)` }}
                  />
                ))}
              </div>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};
